import styled, { css } from "styled-components";

export const h1Css = css`
  font-family: "Frutiger Bold";
  font-size: clamp(32px, 6vw, 56px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};
`;

export const h1 = styled.h1`
  ${h1Css}
`;

export const h2Css = css`
  font-family: "Frutiger Bold";
  font-size: clamp(26px, 3vw, 40px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    letter-spacing: 0.69px;
  }
`;

export const h2 = styled.h2`
  ${h2Css}
`;

export const h3Css = css`
  font-family: "Frutiger Bold";
  font-size: 20px;
  font-size: clamp(20px, 3vw, 34px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};
`;

export const h3 = styled.h3`
  ${h3Css}
`;

export const h4Css = css`
  font-family: "Frutiger Bold";
  font-size: clamp(20px, 4vw, 28px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};
`;

export const h4 = styled.h4`
  ${h4Css}
`;

export const h5Css = css`
  font-family: "Frutiger Bold";
  font-size: clamp(18px, 3vw, 24px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};
`;

export const h5 = styled.h5`
  ${h5Css}
`;

export const h6Css = css`
  font-family: "Frutiger Bold";
  font-size: clamp(18px, 3vw, 22px);
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textHeading};
`;

export const h6 = styled.h6`
  ${h6Css}
`;

export const ParagraphCss = css`
  font-family: "Minion Pro";
  font-size: clamp(16px, 3vw, 18px);
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.textBody};
`;

export const Paragraph = styled.p`
  ${ParagraphCss}
`;

export const ParagraphIngressCss = css`
  font-family: Frutiger Bold;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.textBody};
`;

export const ParagraphIngress = styled.p`
  ${ParagraphIngressCss}
`;

export const ParagraphBigCss = css`
  font-family: "Minion Pro";
  font-size: clamp(22px, 3vw, 24px);
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  color: ${({ theme }) => theme.colors.textBody};
`;

export const ParagraphBig = styled.p`
  ${ParagraphBigCss}
`;

export const ParagraphSmallCss = css`
  font-family: "Minion Pro";
  font-size: 20px;
  color: ${({ theme }) => theme.colors.textBody};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 16px;
  }
`;

export const ParagraphSmall = styled.p`
  ${ParagraphSmallCss}
`;

export const DetailsCss = css`
  font-family: "Frutiger Bold";
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textBody};
`;

export const Details = styled.p`
  ${DetailsCss}
`;
export const DetailsLightCss = css`
  font-family: "Frutiger Light";
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textBody};
`;

export const DetailsLight = styled.span`
  ${DetailsLightCss}
`;
export const DetailsBigCss = css`
  font-family: "Frutiger Bold";
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: ${({ theme }) => theme.colors.textBody};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    letter-spacing: 0.225px;
  }
`;

export const DetailsBig = styled.p`
  ${DetailsBigCss}
`;

export const DetailsSmallCss = css`
  font-family: sans-serif;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.textBody};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 16px;
  }
`;

export const DetailsSmall = styled.p`
  ${DetailsSmallCss}
`;

export const PrimaryButtonCss = css`
  font-family: Frutiger Bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.36px;
  padding: 16px 28px 14px 28px;
  background: ${({ theme }) => theme.colors.primaryPurple};
  border-radius: 48px;
  border: none;
  color: ${({ theme }) => theme.colors.coreLight};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.coreLight};
  }

  &:disabled {
    background: #848484;
    color: ${({ theme }) => theme.colors.textLight};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 18px;
  }
`;

export const SecondaryButtonCss = css`
  ${PrimaryButtonCss};
  background: transparent;
  border: 2px solid ${({ theme }) => theme.colors.primaryPurple};
  color: ${({ theme }) => theme.colors.textHeading};

  &:disabled {
    border: 2px solid #848484;
    color: #848484;
  }
`;

export const TextLinkCss = css`
  font-family: "Frutiger Bold";
  font-size: clamp(16px, 3vw, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: 0.36px;
  text-decoration: none;
  text-decoration-color: transparent;
`;

export const WysiwygCss = css`
  p {
    ${ParagraphCss}
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
  }
  h1 {
    ${h1Css}
  }
  h2 {
    ${h2Css}
  }
  h3 {
    ${h3Css}
  }
  h4 {
    ${h4Css}
  }
  h5 {
    ${h5Css}
  }
  h6 {
    ${h6Css}
  }

  ul {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  li {
    ${ParagraphCss}
    margin-left: 20px;
  }

  a {
    ${TextLinkCss}
    color: ${({ theme }) => theme.colors.primaryPurple} !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }

  img {
    max-width: 100%;
  }

  blockquote {
    ${ParagraphCss}
    margin: 0;
    padding: 0;
    border-left: 4px solid ${({ theme }) => theme.colors.black};
    padding-left: 20px;
  }

  strong {
    font-family: sans-serif;
  }

  em {
    font: sans-serif italic;
  }
`;

export const Wysiwyg = styled.div`
  ${WysiwygCss}
`;
